import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('snipcart-ecommerce', (editor, opts = {}) => {
  let c = opts;
  const default_types = {
    snipcartAddToCart: 'snipcart-product',
    snipcartShowCart: 'snipcart-show-cart',
  };
  const default_labels = {
    snipcartAddToCart: 'Snipcart: Buy Now',
    snipcartShowCart: 'Snipcart: Cart',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Shopping',
    },
    ...opts,
  };
  for (let name in options) {
    if (!(name in c)) c[name] = options[name];
  }

  loadComponents(editor, opts);
});
